const authentication = 'https://propelld.com/api/api-gateway/propelld/sdk/auth';
const application = 'https://propelld.com/api/api-gateway/propelld/sdk/application';
const staticdata = 'https://propelld.com/api/api-gateway/propelld/sdk/static';
const documents = 'https://propelld.com/api/resources';
const staticData = 'https://propelld.com/api/'
const baseUrls = {
    authentication,
    application,
    staticdata,
    documents,
    staticData
};

export default baseUrls;
